var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntrusionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#ECE4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 24L17.3337 21.3333L15.3337 19.3333V15.3333M15.3337 15.3333L12.667 17.3333L13.3337 19.3333M15.3337 15.3333L18.0003 17.3333L20.0003 17.6667M14.667 21.3333L13.3337 24M21.6372 16.078L24.0003 15M22.0003 18L23.745 18.3631M21.0003 19.6667L23.0003 21.3333M15.3337 12.6667C15.3337 12.8435 15.4039 13.013 15.5289 13.1381C15.6539 13.2631 15.8235 13.3333 16.0003 13.3333C16.1771 13.3333 16.3467 13.2631 16.4717 13.1381C16.5968 13.013 16.667 12.8435 16.667 12.6667C16.667 12.4899 16.5968 12.3203 16.4717 12.1953C16.3467 12.0702 16.1771 12 16.0003 12C15.8235 12 15.6539 12.0702 15.5289 12.1953C15.4039 12.3203 15.3337 12.4899 15.3337 12.6667Z",
    stroke: "#1A05B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrusionIcon);
export default __webpack_public_path__ + "static/media/IntrusionIcon.b952027ec047213d6bbf271559dc79a2.svg";
export { ForwardRef as ReactComponent };